import { render, staticRenderFns } from "./Item59Effilabel.vue?vue&type=template&id=2cf03c73&scoped=true&"
import script from "./Item59Effilabel.vue?vue&type=script&lang=js&"
export * from "./Item59Effilabel.vue?vue&type=script&lang=js&"
import style0 from "./Item59Effilabel.vue?vue&type=style&index=0&id=2cf03c73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf03c73",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VBtnToggle } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VBtn,VBtnToggle,VCard,VDivider,VFlex,VImg,VLayout,VProgressLinear})
